import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9rg83ni1sw: FaireBrandEntity = {
  token: "b_9rg83ni1sw",
  type: "brand",
  name: "Le Marké",
  avatarUrl:
    "https://cdn.faire.com/fastly/a7aec8699a245a9dcbe2a5d59308b46998a377d6f774b55ded832336ca23c533.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6b540d4deff08b9b36b181d1704322de7e91d9c97f2eaa4b028154266922afda.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a7aec8699a245a9dcbe2a5d59308b46998a377d6f774b55ded832336ca23c533.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6b540d4deff08b9b36b181d1704322de7e91d9c97f2eaa4b028154266922afda.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 15,
  isInsider: true,
  description:
    "Introducing a reconsideration of ILA – Le Marké. Le Marké is a modern market + grocer. A collection of products designed for savoring the present moment while supporting a more sustainable future.\n\nWe're guided by the unspoken bond that comes from sitting across from one another at the table. A belief in the generosity of a home-cooked meal; in ingredients that celebrate place and season; in the stories we tell; in everyday ways of living and being; in quiet reminders of what's important. We work to simplify sustainability while amplifying ease, wellbeing, and experience. ",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:06.544Z",
    importedBy: "entity-db-cli",
  },
};
